/* eslint-disable react-hooks/exhaustive-deps */
import isEqual from "lodash/isEqual";
import { DependencyList, useMemo, useRef } from "react";

export function useDeepCompareMemoize(dependencies: DependencyList) {
  const dependenciesRef = useRef<DependencyList>(dependencies);
  const signalRef = useRef<number>(0);

  if (!isEqual(dependencies, dependenciesRef.current)) {
    dependenciesRef.current = dependencies;
    signalRef.current += 1;
  }

  return useMemo(() => dependenciesRef.current, [signalRef.current]);
}
